export interface AlertWarning {
  message: string;
  show: boolean;
  type?: TypeAlert;
  title?: string;
}

export enum TypeAlert { EDIT = 'EDIT', LIQUIDATE = 'LIQUIDATE', VOID = 'VOID' };
